import { type IFieldCustomValue, type ObligationCategory, ObligationCategoryValues, ObligationInstanceStatuses } from '@inpart-io/padme-iap';

import { ICONS_NAME } from '@/constants/ui/icons.constants';
import { i18nService } from '@/services/i18n-service';

export const ObligationTypeIcons = new Map<ObligationCategory, string>([
    [ObligationCategoryValues.PAYMENT, ICONS_NAME.PAYMENT],
    [ObligationCategoryValues.ROYALTY_PAYMENT, ICONS_NAME.ROYALTY],
    [ObligationCategoryValues.NON_FINANCIAL_OBLIGATION, ICONS_NAME.NON_FINANCIAL]
]);

export const ObligationInstanceStatusColors = new Map<string, string>([
    [ObligationInstanceStatuses.OVERDUE, '#FF7373'],
    [ObligationInstanceStatuses.UPCOMING, '#8587FF'],
    [ObligationInstanceStatuses.IN_DISPUTE, '#DD2626'],
    [ObligationInstanceStatuses.COMPLETE, '#02C39A'],
    [ObligationInstanceStatuses.TERMINATED, '#324467'],
    [ObligationInstanceStatuses.PENDING, '#5371AC']
]);

export const ObligationInstanceStatusIcons = new Map<string, string>([
    [ObligationInstanceStatuses.OVERDUE, ICONS_NAME.OVERDUE_ICON],
    [ObligationInstanceStatuses.UPCOMING, ICONS_NAME.UPCOMING_ICON],
    [ObligationInstanceStatuses.IN_DISPUTE, ICONS_NAME.IN_DISPUTE_ICON],
    [ObligationInstanceStatuses.COMPLETE, ICONS_NAME.COMPLETE_ICON],
    [ObligationInstanceStatuses.TERMINATED, ICONS_NAME.TERMINATED_ICON],
    [ObligationInstanceStatuses.PENDING, ICONS_NAME.PENDING_ICON]
]);

export const ObligationInstanceDateTypes: IFieldCustomValue[] = [
    { label: i18nService.t('FREQUENCY.DAYS'), value: 'd' },
    { label: i18nService.t('FREQUENCY.WEEKS'), value: 'w' },
    { label: i18nService.t('FREQUENCY.MONTH'), value: 'm' },
    { label: i18nService.t('FREQUENCY.YEARS'), value: 'y' }
];
